import 'Styles/templates/product.scss';

import pdpFirstFold from '../vue/pdp-first-fold/index';
import STB from '../components/scroll-to-bar';
import showMoreLess from '../components/show-more-less';
import AutoplayVideo from '../components/autoplay-video';
import productSliderApp from '../vue/product-slider/index';
import recentlyViewedApp from '../vue/recently-viewed/index';
import StickyBar from '../components/sticky-bar';

pdpFirstFold();
STB();
showMoreLess();
AutoplayVideo();
productSliderApp();
recentlyViewedApp();
StickyBar();

window.stb.init();